import { PurchaseModel } from 'api-hooks/order/common';
import { OrderAdjustmentModel } from 'api-hooks/order-adjustment';
import * as Yup from 'yup';

export const OrderAdjustmentFormSchema = () =>
  Yup.object({
    refId: Yup.string(),
    purchaseRefId: Yup.string().default(''),
    purchaseId: Yup.string().default(''),
    transactionAt: Yup.date().default(new Date()),
    amount: Yup.number().default(0),
  });

export type OrderAdjustmentFormType = Yup.InferType<
  ReturnType<typeof OrderAdjustmentFormSchema>
> & {
  orderAdjustment?: OrderAdjustmentModel;
  purchase?: PurchaseModel;
};
